import { render } from "./AddPromotionModal.vue?vue&type=template&id=7e504686&ts=true"
import script from "./AddPromotionModal.vue?vue&type=script&lang=ts"
export * from "./AddPromotionModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__